module.exports = __webpack_public_path__ + "img/agent-module.21b6479b.svg";